import api from "../apiConfig";
const paramsFactory = (p) => {
  const params = new URLSearchParams();
  if (p) {
    Object.keys(p).forEach((key) => {
      if (p[key] !== null && p[key] !== undefined && p[key] !== "") {
        params.append(key, p[key]);
      }
    });
  }
  return params;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/bonus?${p}`);
  },
  getById(id) {
    return api.get(`/api/v1/bonus/${id}`);
  },
  update(data) {
    return api.put(`/api/v1/bonus/${data.id}`, data);
  },
  create(data) {
    return api.post(`/api/v1/bonus`, data);
  },
  delete(id) {
    return api.delete(`/api/v1/bonus/${id}`);
  },
  changeStatus(id) {
    return api.put(`/api/v1/bonus/status/${id}`);
  },
  changeStatusWithInfo(data) {
    return api.put(`/api/v1/bonus/status/${data.id}`, data);
  },
  changeMultiBonusStatus(data) {
    return api.put(`/api/v1/bonus-multi-status`, data);
  },
  exportToExcel(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/bonus?${p}`, {
      responseType: "blob",
    });
  },
};
